import React from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

const Manufacturing: React.FC = () => {
  const processSteps = [
    {
      step: "01",
      title: "Raw Material Selection",
      description: "Virgin and recycled pulp sourced from certified suppliers",
      image: "/assets/skytion/company/Facility photo.png",
      icon: "/assets/skytion/icons/Softness Icon.png"
    },
    {
      step: "02", 
      title: "Pulp Processing",
      description: "Advanced machinery processes pulp into tissue base material",
      image: "/assets/skytion/company/ Bulk ordering graphics.png",
      icon: "/assets/skytion/icons/Durability Icon.png"
    },
    {
      step: "03",
      title: "Tissue Formation",
      description: "Precise manufacturing creates various ply configurations",
      image: "/assets/skytion/products/professional-product-photography.png",
      icon: "/assets/skytion/icons/Absorbency Icon.png"
    },
    {
      step: "04",
      title: "Quality Testing",
      description: "Rigorous quality control ensures consistency and standards",
      image: "/assets/skytion/brand/certification badge .png",
      icon: "/assets/skytion/icons/Softness Icon.png"
    }
  ];

  return (
    <>
      <Helmet>
        <title>Manufacturing Process - Skytion Enterprises</title>
        <meta name="description" content="Discover Skytion Enterprises' state-of-the-art tissue manufacturing process. From virgin & recycled pulp to premium Skysun brand products." />
        <meta name="keywords" content="tissue manufacturing, skytion process, virgin pulp, recycled pulp, noida facility, quality control" />
      </Helmet>

      {/* Hero Section */}
      <section className="bg-light py-5">
        <Container>
          <Row className="text-center">
            <Col lg={8} className="mx-auto">
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <Badge bg="primary" className="mb-3">Est. 2022</Badge>
                <h1 className="display-4 mb-3">Manufacturing Excellence</h1>
                <p className="lead mb-4">
                  State-of-the-art tissue manufacturing facility in Noida producing premium Skysun brand products 
                  from virgin and recycled pulp with 80% women workforce.
                </p>
                <div className="d-flex justify-content-center gap-3 mb-4">
                  <Badge bg="success">ISO Quality</Badge>
                  <Badge bg="info">9 Products</Badge>
                  <Badge bg="warning">Export Ready</Badge>
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Manufacturing Process */}
      <section className="py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-5 mb-3">From Pulp to Premium Products</h2>
            <p className="lead">Our 4-step manufacturing process ensures consistent quality and reliability</p>
          </div>
          
          <Row className="g-4">
            {processSteps.map((step, index) => (
              <Col lg={6} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                >
                  <Card className="h-100 shadow-sm">
                    <div className="position-relative">
                      <Card.Img 
                        variant="top" 
                        src={step.image} 
                        alt={step.title}
                        style={{ height: '200px', objectFit: 'cover' }}
                      />
                      <div className="position-absolute top-0 start-0 m-3">
                        <Badge bg="primary" className="fs-6 px-3 py-2">
                          Step {step.step}
                        </Badge>
                      </div>
                    </div>
                    <Card.Body>
                      <div className="d-flex align-items-center mb-3">
                        <img 
                          src={step.icon} 
                          alt={step.title}
                          style={{ width: '40px', height: '40px' }}
                          className="me-3"
                        />
                        <Card.Title>{step.title}</Card.Title>
                      </div>
                      <Card.Text>{step.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Facility Information */}
      <section className="bg-light py-5">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-6 mb-4">Noida Manufacturing Facility</h2>
              <p className="lead mb-4">
                Located in Ecotech Phase 3, Gautam Buddha Nagar, our modern facility operates with 
                advanced machinery and a dedicated workforce committed to quality.
              </p>
              
              <Row className="mt-4">
                <Col md={3}>
                  <div className="facility-stat">
                    <h3 className="display-6 text-primary">2022</h3>
                    <p>Established</p>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="facility-stat">
                    <h3 className="display-6 text-success">80%</h3>
                    <p>Women Workforce</p>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="facility-stat">
                    <h3 className="display-6 text-info">9</h3>
                    <p>Product Lines</p>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="facility-stat">
                    <h3 className="display-6 text-warning">3</h3>
                    <p>Markets Served</p>
                  </div>
                </Col>
              </Row>
              
              <div className="mt-4">
                <h5>Contact Our Manufacturing Team</h5>
                <p className="mb-0">📞 +91 8920065965 | 📧 sales@skytion.in</p>
                <p>Bulk orders and custom specifications available</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Manufacturing;